export default "__VITE_ASSET__4nq$5fOJ__"